<template>
  <div class="container">
    <div class="btn">
      <wechat-open-app :extinfo="obj"></wechat-open-app>
    </div>
  </div>
</template>

<script>
import WechatOpenApp from '../../components/wechat-open-app/wechat-open-app'
import {envMixin} from "../../assets/js/mixin/global";

export default {
  name: "wechatOpenApp",
  mixins: [envMixin],
  components: {
    'wechat-open-app': WechatOpenApp
  },
  data() {
    return {
      obj: {
        id: 11,
        type: 'bbs'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.container{
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn{
    position: absolute;
    top: 300px;
    left: 20px;
    width: 234px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    overflow: hidden;
  }
}
</style>